export const questionColours = {
  1: "#d4e5f1",
  2: "#f6edf9",
  3: "#e2f5f1",
  4: "#FCF3CF",
  5: "#FAE5D3",
  6: "#ded8d8",
  7: "#FBFCFC",
  8: "#EAEDED",
  9: "F5C3F3",
};

export const groupColours = {
  1: "#319be6",
  28: "#319be6",
  30: "#319be6",
  2: "#d3894b",
  29: "#d3894b",
  31: "#d3894b",
  7: "#676767",
  8: "#676767",
  9: "F5C3F3",
};
